export default "__VITE_ASSET__5eecd9db__"